<template>
  <div class="myinvoice">
    <div class="fr ac jsb">
      <p class="mb20 black bold fz14">我的发票</p>
      <el-button size="mini" v-permission="849" type="primary" class="mb20" @click="addinvoiceVisible = true">新增发票
      </el-button>
    </div>
    <div class="fr ac jsa fw">
      <invoice-cell
          :info="i"
          v-for="i in invoice_list"
          :key="i.invoice_id"
          @updateDefaultInvoice="updateDefaultInvoice"
          @deleteInvoice="deleteInvoice"
          @updateInvoice="updateInvoice"
      />
      <div v-if="invoice_list %2 !=0" style="width:40%"></div>
    </div>
    <div class="fr ac jc">
      <el-pagination
          layout="prev, pager, next"
          :total="invoice_total"
          :hide-on-single-page="true"
          :current-page.sync="invoice_page"
      ></el-pagination>
    </div>
    <add-invoice
        :invoiceVisible.sync="addinvoiceVisible"
        @cloneVisible="invoiceClick"
        :info="obj"
        :type="type"
    />
  </div>
</template>

<script>
import InvoiceCell from "./InvoiceCell";
import AddInvoice from "@/components/AddInvoice";

export default {
  props: {},
  data() {
    return {
      type: "add",
      invoice_page: 1,
      invoice_total: 0,
      invoice_list: [],
      addinvoiceVisible: false,
      obj: {}
    };
  },
  computed: {},
  created() {
    this.getInvoices();
  },
  mounted() {
  },
  watch: {
    invoice_page(n) {
      this.getInvoices();
    },
    addinvoiceVisible(n) {
      if (!n) {
        setTimeout(() => {
          this.type = "add";
        }, 1000);
        this.obj = {};
      }
    }
  },
  methods: {
    updateInvoice(obj) {
      this.type = "edit";
      this.obj = obj;
      this.addinvoiceVisible = true;
    },
    // 设置默认发票
    updateDefaultInvoice(id) {
      this.post("invoiceInterfaces/v1.0/updateDefaultInvoice", {
        invoice_id: id
      }).then(res => {
        this.getInvoices();
      });
    },
    deleteInvoice(id) {
      this.$confirm("此操作将删除该发票, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.post("invoiceInterfaces/v1.0/deleteInvoice", {
          invoice_id: id
        }).then(res => {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.getInvoices();
        });
      });
    },
    invoiceClick(obj) {
      this.addinvoiceVisible = false;
      if (obj != false) {
        this.getInvoices();
      }
    },
    // 获取发票
    getInvoices() {
      this.post("invoiceInterfaces/v1.0/getInvoices", {
        page: this.invoice_page
      }).then(res => {
        if (res.status == "ok") {
          this.invoice_list = res.data;
          this.invoice_total = res.total;
        }
      });
    }
  },
  components: {
    InvoiceCell,
    AddInvoice
  }
};
</script>

<style scoped lang="scss">
.myinvoice {
}
</style>



// WEBPACK FOOTER //
// src/page/me/invoice/index.vue